import { defineStore } from "pinia";

import AuthenticationService from "@/services/AuthenticationService";
import type { GrantedPermissions } from "@/services/PermissionsService";

type State = {
    token: string | null;
    permissions: GrantedPermissions | null;
};

export type App = "picking" | "completion" | "expedition" | "palletChecker";

function getCachedPermissions(): GrantedPermissions {
    try {
        return JSON.parse(localStorage.getItem("permissions") || "{}");
    } catch {
        return {};
    }
}

export const useAuthStore = defineStore("authStore", {
    state: (): State => ({
        token: null,
        permissions: null,
    }),
    actions: {
        load(): void {
            this.token = localStorage.getItem("token");
            this.permissions = getCachedPermissions();
        },
        async refreshPermissions(): Promise<void> {
            this.setPermissions(await AuthenticationService.getPermissions());
        },

        async signIn(email: string, password: string): Promise<void> {
            const response = await AuthenticationService.signIn(email, password);
            this.setToken(response.token);
            this.setPermissions(response.permissions);
        },
        signOut(): void {
            localStorage.removeItem("token");
            localStorage.removeItem("permissions");
            this.$reset();
        },

        setToken(token: string) {
            this.token = token;
            localStorage.setItem("token", token);
        },
        setPermissions(permissions: GrantedPermissions) {
            this.permissions = permissions;
            localStorage.setItem("permissions", JSON.stringify(this.permissions));
        },
    },
    getters: {
        isAuthenticated: (state) => state.token !== null,
    },
});
